/* global console: true, window: true, document: true */
/* jshint forin:true, noarg:true, noempty:true, eqeqeq:true, bitwise:true, strict:true, undef:true, unused:true, browser:true, devel:true, jquery:true, indent:4, maxerr:50, boss:true, trailing:true, white:true, sub:true*/

/**
*
* @name elPreload
* @description A preloader
* @param {jQuery} jQuery jQuery namespace
* @param {array} targets Array of target jQuery elements to preload
* @param {object} options Option values to customize preloader functionality
* @param {number} preloadTimeoutTime [options.preloadTimeoutTime=8000] Time to trigger preload timeout (load all images
* @param {boolean} [options.debug=false] debug Whether to show debug messages or not
* @param {boolean} [options.loadHidden=false] loadHidden Whether to load hidden images or not, loads hidden images by default
* @param {function} [options.callback=undefined] callback Function to run once preload is complete
* @param {string} [options.imagePath=undefined] imagePath String containing image path to load
* @param {string} [options.ignoreTargets=''] ignoreTargets Comma separated list of targets to ignore (must be in selector format)
* @returns {undefined} This function doesn't return anything
* @see: http://flesler.blogspot.com/2008/01/jquerypreload.html
*/
window.elPreload = function elPreload(jQuery, targets, options) {

	'use strict';

	var $ = jQuery, // Typical $ for jQuery alias
		defaults = {
			// callback: undefined,
			debug: false,
			// imagePath: undefined,
			ignoreTargets: '',
			loadHidden: true,
			preloadTimeoutTime: 8000
		},
		callback,
		targetImages = [],
		loadHidden = true,
		debug = false,
		t = 0, // Counter for for-loops
		preloadTimeout,
		preloadTimeoutTime,
		preloadTimeoutOverride = false,
		$preloadImages,
		// Reset these every preloadnext event this will track images to load, and images that have (or failed to) load
		imagesLoaded = 0,
		imagesToLoad = 0,
		$target,
		$images,
		$preloadTargets,
		imagePaths;

	if (typeof jQuery === 'undefined' || (typeof targets === 'undefined' || !targets.length)) return;

	$ = jQuery;
	$preloadImages = $();

	// Update defaults with options
	options = $.extend(defaults, options);

	// For easier variable calls
	debug = options.debug;
	callback = options.callback;
	loadHidden = options.loadHidden;
	preloadTimeoutTime = options.preloadTimeoutTime;

	/**
	* @function completePath
	* @description Normalizes a given url into a full (absolute) path with the given document url
	* @param {string} url url to normalize
	* @param {string} urlDocument Generally a base document URL via window.location.href
	* @returns {string} a normalized URL
	*/
	function completePath(url, urlDocument) {

		var path = [],
		dirTraversal = [],
		a = document.createElement('a'),
		i = 0;

		// Validate Input
		if (typeof url !== 'string') return false;
		if (typeof urlDocument !== 'string') return false;

		a.href = urlDocument;

		// Full Path
		if (url.charAt(0) === '/') return a.protocol + '//' + a.hostname + url;

		// Absolute path
		if (url.indexOf('://') !== -1) return url;

		// Relative Path
		path = a.pathname.split('/');

		// Remove document from path
		if (path[path.length - 1] !== '') path[path.length - 1] = '';
		path.pop();

		// Directory depth
		dirTraversal = url.match(/\.\.\//g);
		if (typeof dirTraversal === 'object' && dirTraversal !== null) {

			// Traverse up
			for (i = 0; i < dirTraversal.length; i++) {

				if (dirTraversal[i] === '../') path.pop();

			}
			url = url.replace(/\.\.\//g, '');

		}

		return a.protocol + '//' + a.hostname + path.join('/') + '/' + url;

	}

	/**
	* @function createPreloadTimeout
	* @description Creates the preload timeout (with time based in options.preloadTimeoutTime in milliseconds). Will clear the previous timeout.
	* @returns {undefined} This function does not return anything
	*/
	function createPreloadTimeout() {

		// No timeout if preloadTimeoutTime is 0
		if (options.preloadTimeoutTime < 0) return;

		if (typeof preloadTimeout !== 'undefined') window.clearTimeout(preloadTimeout);

		preloadTimeout = window.setTimeout(function () {

			if (debug) console.log('lazyPreload: Timeout fired');

			preloadTimeoutOverride = true;
			$(window).trigger('preloadComplete');

		}, preloadTimeoutTime);

	}

	/**
	* @function completionHandler
	* @description Completion handler that should be run after all images in a section has been loaded. Makes a call to load the next set of images, or triggers preload completion if there are no more targets.
	* @returns {undefined} This function does not return anything
	*/
	function completionHandler() {

		if (preloadTimeoutOverride) return;

		if (targetImages.length !== 0) {

			createPreloadTimeout();
			if (debug) console.log('lazyPreload: Loading next images in: ', targetImages[targetImages.length - 1].$target);
			$(window).trigger('preloadNext');

		} else if (targetImages.length === 0) {

			if (debug) console.log('lazyPreload: All targets loaded: triggering preloadComplete');
			$(window).trigger('preloadComplete');

		}

	}

	/**
	* @function onLoadHandler
	* @description Load handler that should be called in an image's onload, allows track of image load progress. Will call completionHandler once all images are loaded.
	* @returns {undefined} This function does not return anything
	*/
	function onloadHandler() {

		/* jshint validthis:true */
		if (debug) console.log('lazyPreload: Loaded ' + this.src + ' ' + (imagesLoaded + 1) + ' out of ' + imagesToLoad);
		imagesLoaded++;

		if (imagesLoaded >= imagesToLoad)
			completionHandler();

	}

	/**
	* @function onErrorHandler
	* @description Error handler that should be called in an image's onerror, allows track of image load progress. Will call completionHandler once all images are loaded. This function is here to allow progression even if image fails to load.
	* @returns {undefined} This function does not return anything
	*/
	function onErrorHandler() {

		/* jshint validthis:true */
		if (debug) console.log('lazyPreload: Failed to load ' + this.src + ' ' + (imagesLoaded + 1) + ' out of ' + imagesToLoad);
		imagesLoaded++;

		if (imagesLoaded >= imagesToLoad)
			completionHandler();

	}

	/**
	* @function getImages
	* @description Get data-src and adds it into imagePaths
	* @returns {undefined} This function does not return anything
	*/
	function getImages() {

		/* jshint validthis:true */
		var $this = $(this),
		imagePath = $this.data('src');

		if (!loadHidden && !$this.is(':visible')) return;

		if (typeof imagePath === 'undefined' || imagePath.length === 0) return;

		// Do not allow elements with ignoreTargets to be preloaded
		if ($this.is(options.ignoreTargets)) return;

		// Handle this outside of script
		// Append options.imagePath to imagePath found in data src
		// if(typeof options.imagePath !== 'undefined' && options.trim(options.imagePath).length !== 0)
			// imagePath = options.imagePath+imagePath;

		// Push only if there are no duplicates
		if (imagePaths.indexOf(imagePath) === -1)
			imagePaths.push(completePath(imagePath, window.location.href));

		$preloadImages = $preloadImages.add($this);

	}

	// Build array of images to preload per targets
	for (t = 0; t < targets.length; t++) {

		$target = targets[t];

		// If target is image, $images is target
		if ($target.is('img')) $images = $target;
		// Otherwise find all images in target
		else $images = $target.find('img');

		$preloadTargets = $target.find('.preload').addBack('.preload');
		imagePaths = [];

		if ($target.length === 0) continue;

		$images.each(getImages);

		$preloadTargets.each(getImages);

		if (debug) console.info('lazyPreload: ' + $target.attr('id') + ': Found: ' + imagePaths.length + ' images');

		if (imagePaths.length !== 0) {

			$target.data('images_to_load', imagePaths.length);
			targetImages.unshift({
				$target: $target,
				imagePaths: imagePaths
			});

		}

	}

	// Loads the next section's images on event call, if there is still sections to load, trigger the event again
	$(window).on('preloadNext', function () {

		var data = targetImages.pop(),
			$target,
			imagePaths,
			image,
			i = 0;

		$target = data.$target;
		imagePaths = data.imagePaths;

		imagesLoaded = 0;
		imagesToLoad = imagePaths.length;

		if (debug) console.info('lazyPreload: loading images in: ' + $target.attr('id') + ' with ' + imagePaths.length + ' images');

		for (i = 0; i < imagePaths.length; i++) {

			image = new Image();
			image.onload = onloadHandler;
			image.onerror = onErrorHandler;
			image.src = imagePaths[i];

		}

	});

	$(window).one('preloadComplete', function () {

		var preloadImagesLoaded = 0;

		if (debug) console.log('lazyPreload: timeout cleared');

		window.clearTimeout(preloadTimeout);

		$preloadImages.each(function() {

			var $this = $(this),
			dataSrc = $this.data('src');

			$this.one('load error', function() {

				if (debug) console.info('lazyPreload: image swapped', $this.attr('src'), preloadImagesLoaded + ' / ' + ($preloadImages.length - 1));
				preloadImagesLoaded++;

				if (preloadImagesLoaded >= $preloadImages.length) {

					if (debug) console.info('lazyPreload: all images swapped');
					$(window).trigger('preloadImagesLoaded');

				}

		});

			if (typeof dataSrc !== 'undefined') $this.attr('src', dataSrc);

		});

		// Set ALL imgs with data-src
		$('img').not($preloadImages).each(function() {

				var $this = $(this),
				dataSrc = $this.data('src');

				if (typeof dataSrc !== 'undefined') $this.attr('src', dataSrc);

		});

		// Set ALL elements preload class
		$('.preload').each(function() {

			var $this = $(this),
			dataSrc = $this.data('src');

			if (typeof dataSrc !== 'undefined') $this.css({backgroundImage: 'url(' + $this.data('preloadbackground') + ')'});

		});

		if (typeof callback !== 'undefined') callback();

		$(window).trigger('postPreloadComplete');

	});

	if (debug) console.log('lazyPreload: timeout set');

	// If images take too long to preload, trigger a preloadComplete to force imgs to load
	createPreloadTimeout();

	$(window).trigger('preloadNext');

};

